module.exports = "<div *ngIf=\"visible\" class=\"loading\">\r\n    <div class=\"loader\"></div>\r\n</div>\r\n<div *ngIf=\"visible\" class=\"overlay\"></div>"